import { render, staticRenderFns } from "./Intro_pages.vue?vue&type=template&id=ef644024"
import script from "./Intro_pages.vue?vue&type=script&lang=js"
export * from "./Intro_pages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports